import React from "react"
import Test1 from "./Test1calendar"
import Test2 from "./Test2calendar"
import ProjNavChain from "../DevServices/ProjNavСhain"
//import "./test.css" app/frontend/src/Devices/DevServices/ProjNavСhain.jsx

const Test = (props) => {

  return <>
  <h1>Hello Test</h1>
  <ProjNavChain />
{/*   <Test1 />
  <hr />
  <Test2 /> */}
  </>
}

export default Test